module.exports = __webpack_public_path__ + "public/img/icon_zaixianshangc.727454df.png";